module.exports = __webpack_public_path__ + "static/media/chess-knight-alt.a335912d.svg";